import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { TranslateService } from '@ngx-translate/core'
import { type Observable } from 'rxjs'
import { type hr } from 'efd-cpt-b2c-backend-interfaces-ts'

export type Country = hr.emilfreydigital.b2c_auth_server.rest.country.dto.CountryDto

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private readonly apiUrl

  constructor (
    private readonly http: HttpClient,
    private readonly translate: TranslateService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.apiUrl = this.remoteConfigService.get('b2c.baseUrl')
  }

  getCountries (): Observable<Country[]> {
    return this.http.get<Country[]>(this.apiUrl + '/countries')
  }
}
